
import React from "react";
import { Layout, Typography, Row, Col, Card, Collapse, Form, InputNumber, Upload, Button, message, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Title } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const criteriaData = [
  {
    key: 1,
    title: "Студенты и их достижения",
    indicators: [
      {
        label: "1 место (международные соревнования)",
        name: "studentInt1",
        docLabel: "Сертификаты (PDF)"
      },
      
   
      {
        label: "Медальоны (международные)",
        name: "studentIntMedals",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "1 место (республиканские соревнования)",
        name: "studentNat1",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "2 место (республиканские соревнования)",
        name: "studentNat2",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "3 место (республиканские соревнования)",
        name: "studentNat3",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "Прошли демоэкзамен и получили Skills Passport, %",
        name: "skillsPercent",
        docLabel: "Приказ, протокол ИАК, Skills Passport (PDF)"
      }
    ]
  },
  {
    key: 2,
    title: "Кадровый состав",
    indicators: [
      {
        label: "Доля педагогов с международными сертификатами, %",
        name: "intlTeachers",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "Доля педагогов исследователей и экспертов, %",
        name: "researchTeachers",
        docLabel: "Свидетельства / приказы (PDF)"
      },
      {
        label: "Доля специалистов с производственным опытом ≥ 3 лет, %",
        name: "practTeachers",
        docLabel: "Метод. форма (PDF)"
      },
     
      {
        label: "2 место (республиканские конкурсы педагогов)",
        name: "teacherNat2",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "3 место (республиканские конкурсы педагогов)",
        name: "teacherNat3",
        docLabel: "Сертификаты (PDF)"
      }
    ]
  },
  {
    key: 3,
    title: "Международное сотрудничество",
    indicators: [
      {
        label: "Количество студентов, участвующих в академической мобильности",
        name: "mobStudents",
        docLabel: "Приказ (PDF)"
      },
      {
        label: "Количество педагогов, участвующих в академической мобильности",
        name: "mobTeachers",
        docLabel: "Приказ (PDF)"
      }
    ]
  },
  {
    key: 4,
    title: "Международные требования и стандарты",
    indicators: [
      {
        label: "Количество образовательных программ, реализуемых по международным требованиям",
        name: "intlProgramsCount",
        docLabel: "Свидетельство об аккредитации (PDF)"
      },
      {
        label: "Доля студентов, обучающихся по международным программам, %",
        name: "intlStudentsPercent",
        docLabel: "Свидетельство + ссылка (PDF)"
      }
    ]
  },
  {
    key: 5,
    title: "Карьерные перспективы выпускников",
    indicators: [
      {
        label: "Доля студентов, получивших сертификат по международным программам, %",
        name: "certifiedStudents",
        docLabel: "Сертификаты (PDF)"
      },
      {
        label: "Доля трудоустроенных выпускников в первый год, %",
        name: "employedGraduates",
        docLabel: "НОБД + подпись директора (PDF)"
      }
    ]
  },
  {
    key: 6,
    title: "Развитие предпринимательства",
    indicators: [
      {
        label: "Наличие бизнес-центров и поддержки",
        name: "hasStartupCenter",
        input: "select",
        options: ["Есть", "Отсутствует"],
        docLabel: "Приказ / положение (PDF)"
      },
      {
        label: "Количество реализованных стартап-проектов за 3 года",
        name: "startupCount",
        docLabel: "Учредительные документы (PDF)"
      }
    ]
  }
];

const SurveyCriteriaPage = () => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    console.log("Форма отправлена:", values);
    message.success("Данные сохранены");
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ background: '#fff', padding: '0 32px', borderBottom: '1px solid #f0f0f0' }}>
        <Title level={4} style={{ margin: 0 }}>Критерии и показатели</Title>
      </Header>
      <Content style={{ padding: '32px 48px' }}>
        <Card style={{ borderRadius: 12 }}>
          <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Collapse accordion>
              {criteriaData.map((criterion) => (
                <Panel header={criterion.title} key={criterion.key}>
                  <Row gutter={[16, 16]}>
                    {criterion.indicators.map((indicator) => (
                      <Col xs={24} md={12} key={indicator.name}>
                        <Form.Item
                          name={indicator.name}
                          label={indicator.label}
                          rules={[{ required: true, message: 'Заполните поле' }]}
                        >
                          {indicator.input === "select" ? (
                            <Select>
                              {indicator.options.map(opt => <Option key={opt} value={opt}>{opt}</Option>)}
                            </Select>
                          ) : (
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />
                          )}
                        </Form.Item>
                        {indicator.docLabel && (
                          <Form.Item label={indicator.docLabel}>
                            <Upload beforeUpload={() => false}>
                              <Button icon={<UploadOutlined />}>Загрузить</Button>
                            </Upload>
                          </Form.Item>
                        )}
                      </Col>
                    ))}
                  </Row>
                </Panel>
              ))}
            </Collapse>
            <Form.Item style={{ marginTop: 24 }}>
              <Button type="primary" htmlType="submit">Сохранить</Button>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default SurveyCriteriaPage;